import { Flex } from 'antd';

import styled from '@emotion/styled';

/**
 * Room for a 12-digit amount in a `size="large"` Input: at the 14px Inter the
 * theme sets for large inputs (`inputFontSizeLG`) a digit advances ~8px, so 12
 * of them plus 22px of horizontal padding and 2px of border need ~120px — 160
 * leaves headroom for a wider fallback font.
 */
const PRICE_FIELD_MIN_WIDTH = 160;

/** Marks the price field inside {@link PriceVatRow}. */
export const PRICE_FIELD_CLASS = 'price-field';

/** `data-testid` of a {@link PriceVatRow}, so tests can assert the pairing. */
export const PRICE_VAT_ROW_TESTID = 'price-vat-row';

/**
 * Puts "Price before VAT" and "VAT rate" on a single row: the price field —
 * the one tagged with {@link PRICE_FIELD_CLASS} — grows into whatever slack the
 * rate buttons leave but never shrinks below room for 12 digits, and the pair
 * wraps back onto two lines rather than squeezing when the modal is too narrow.
 *
 * Shared by the billing-period service modal and the invoice line-item list.
 * antd is configured with `prefixCls="ui"` here (see App.tsx).
 */
export const PriceVatRow = styled(Flex)`
  > .ui-form-item {
    flex: 0 0 auto;
  }

  > .ui-form-item.${PRICE_FIELD_CLASS} {
    flex: 1 1 ${PRICE_FIELD_MIN_WIDTH}px;
    min-width: ${PRICE_FIELD_MIN_WIDTH}px;
  }
`;
